
import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  Divider,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import Header from "../../Dashboard/Header";

export default function ManualReconcile() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  // Sample data - would typically come from API
  const [unreconciledTransactions, setUnreconciledTransactions] = useState([
    {
      id: 1,
      date: "11-Apr-24",
      particulars: "Origin Venture",
      instNo: "",
      deposit: "2,11,675.00",
      withdrawal: "",
    },
  ]);

  return (
    <Box mt="80px" ml="20px" mr="20px">
      {/* Header Section */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection="row"
      >
        <Header title="Manual Bank Reconcilation" />

        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: colors.blueAccent[700], // Custom background color
              color: colors.primary[150], // Custom text color
              "&:hover": {
                backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                color: colors.primary[150], // Maintain the same text color on hover
              },
            }}
            type="button"
          >
            Reconcile
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              borderColor: "black",
              color: "white",
            }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
      </Box>

      {/* Account Info */}
      <Paper
        sx={{
          p: 2,
          mb: 2,
          backgroundColor: colors.primary[400],
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Bank Ledger : SBI-40023521859
        </Typography>
        <Typography variant="h4">Period : 1-Apr-24 to 3-Sep-25</Typography>
      </Paper>

      {/* Unreconciled Transactions */}
      <Typography variant="h3" gutterBottom sx={{ mt: 3 }}>
        Unreconciled Transactions
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table>
          <TableHead sx={{ backgroundColor: colors.blueAccent[700] }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Particulars</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Inst No.</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Deposit</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Withdrawal</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {unreconciledTransactions.map((transaction) => (
              <TableRow key={transaction.id}>
                <TableCell>{transaction.date}</TableCell>
                <TableCell>{transaction.particulars}</TableCell>
                <TableCell>{transaction.instNo}</TableCell>
                <TableCell>{transaction.deposit}</TableCell>
                <TableCell>{transaction.withdrawal}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <Chip
            label={`Difference: ${unreconciledTransactions[0].deposit}`}
            sx={{
              backgroundColor: colors.blueAccent[700],
              fontSize: "1rem",
              padding: "10px 15px",
            }}
          />
        </Box>
      </TableContainer>

      <Divider sx={{ my: 3 }} />

      {/* Potential Matches Section */}
      <Typography variant="h6" gutterBottom>
        Potential Matches
      </Typography>

      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ mt: 3, color: colors.greenAccent[500] }}
      >
        Available Only in Bank
      </Typography>

      {/* This would typically be populated with data */}
      <Box
        sx={{
          p: 3,
          border: `1px dashed ${colors.grey[300]}`,
          borderRadius: 1,
          textAlign: "center",
          backgroundColor: colors.primary[900],
        }}
      >
        <Typography variant="body2" color="textSecondary">
          No potential matches found
        </Typography>
      </Box>
    </Box>
  );
}

